import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, mergeProps as _mergeProps, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "gorda-map" }
const _hoisted_2 = { class: "gorda-map__header" }
const _hoisted_3 = { class: "gorda-map__title-group" }
const _hoisted_4 = { class: "gorda-map__title" }
const _hoisted_5 = { class: "gorda-map__count-pill" }
const _hoisted_6 = { class: "gorda-map__search form-group" }
const _hoisted_7 = { class: "gorda-map__search-control" }
const _hoisted_8 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_9 = {
  key: 0,
  class: "is-invalid"
}
const _hoisted_10 = { class: "gorda-map__surface" }

import {computed, onBeforeMount, onBeforeUnmount, ref, Ref} from 'vue'
import {storeToRefs} from 'pinia'
import {useDriversStore} from '@/services/stores/DriversStore'
import {Field} from 'vee-validate'
import Map from '@/components/maps/Map.vue'
import {PlaceInterface} from '@/types/PlaceInterface'

// Freshness thresholds derived from `last_seen_at` (see design.md D6).
const AGING_AFTER_MS = 60_000
const STALE_AFTER_MS = 120_000
const TICK_INTERVAL_MS = 15_000

interface Props {
  visible?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DriverMap',
  props: {
    visible: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const driversStore = useDriversStore()
const {connectedDrivers} = storeToRefs(driversStore)
const searchDriver: Ref<string> = ref('')
const icon: Ref<string> = ref(process.env.VUE_APP_DRIVER_LOC_IMAGE_URL as string)
const nowTick: Ref<number> = ref(Date.now())
let tickInterval: ReturnType<typeof setInterval> | undefined

function computeFreshness(lastSeenAt: number | undefined, now: number): NonNullable<PlaceInterface['freshness']> {
  if (typeof lastSeenAt !== 'number') {
    return 'fresh'
  }
  const age = now - lastSeenAt
  if (age >= STALE_AFTER_MS) return 'stale'
  if (age >= AGING_AFTER_MS) return 'aging'
  return 'fresh'
}

function formatElapsed(lastSeenAt: number, now: number): string {
  const elapsed = now - lastSeenAt
  if (elapsed < AGING_AFTER_MS) {
    return `${Math.floor(elapsed / 1000)}s`
  }
  return `${Math.floor(elapsed / 60_000)}m`
}

const filteredDrivers = computed<Array<PlaceInterface>>(() => {
  const search = searchDriver.value
  const now = nowTick.value
  const matched = search.length === 0
    ? connectedDrivers.value
    : connectedDrivers.value.filter(place => place.name.toLowerCase().includes(search.toLowerCase()))

  return matched.map(place => {
    const freshness = computeFreshness(place.lastSeenAt, now)
    if (freshness === 'fresh') {
      return {...place, freshness}
    }
    return {
      ...place,
      freshness,
      name: `${place.name} · ${formatElapsed(place.lastSeenAt as number, now)}`,
    }
  })
})

onBeforeUnmount(() => {
  driversStore.offOnlineDrivers()
  if (tickInterval !== undefined) {
    clearInterval(tickInterval)
  }
})

onBeforeMount(() => {
  driversStore.getOnlineDrivers()
  tickInterval = setInterval(() => {
    nowTick.value = Date.now()
  }, TICK_INTERVAL_MS)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "gorda-map__icon-chip" }, [
          _createElementVNode("em", { class: "fas fa-car-side" })
        ], -1)),
        _createElementVNode("h6", _hoisted_4, _toDisplayString(_ctx.$t('common.models.drivers_connected')), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(filteredDrivers.value.length), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(Field), {
          name: "driver",
          type: "search",
          modelValue: searchDriver.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchDriver).value = $event))
        }, {
          default: _withCtx(({ field, errorMessage, meta }) => [
            _createElementVNode("div", _hoisted_7, [
              _cache[2] || (_cache[2] = _createElementVNode("em", { class: "fas fa-magnifying-glass gorda-map__search-icon" }, null, -1)),
              _withDirectives(_createElementVNode("input", _mergeProps({
                class: "form-control form-control-sm gorda-map__search-input",
                type: "search",
                "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                placeholder: _ctx.$t('common.placeholders.search')
              }, field, { autocomplete: "off" }), null, 16, _hoisted_8), [
                [_vModelText, field.value]
              ])
            ]),
            (errorMessage || !meta.dirty)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(errorMessage), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(Map, {
        places: filteredDrivers.value,
        icon: icon.value,
        visible: props.visible
      }, null, 8, ["places", "icon", "visible"])
    ])
  ]))
}
}

})